const {logger} = require('./utils')
const {GAME_CALLBACK} = require(`./constants`)
const {tracking, OPEN_ANNOUNCEMENTS, ANNOUNCEMENT_READY} = require('./tracking')
const {
    getNewAnnouncements,
    getAnnouncementsCache,
    setLoginData,
    getLoginData,
    loadMessages,
    loadLoginMessages
} = require('./announcement-utils')

module.exports = (context, adapter) => {
    const onLogin = (data) => {
        logger.info('Login event triggered', data)
        setLoginData(context, adapter)(data)
        const loginData = getLoginData()

        onGetMessageStatus(adapter.loginCmd)(loginData)

        return loadLoginMessages(context)(loginData)
    }

    const onLogout = () => {
        context.once(adapter.loginCmd, onGetMessageStatus(adapter.loginCmd))
    }

    const onGetMessageStatus = (eventName) => async (data) => {
        setLoginData(context, adapter)(data)
        const loginData = getLoginData()
        logger.log(` onGetMessageStatus - ${eventName}`, loginData)
        const countOfActiveAnnouncements = await getNewAnnouncements(loginData)
        context.gameApi.invokeFn(
            GAME_CALLBACK.UNREAD_ANNOUNCEMENTS,
            countOfActiveAnnouncements
        )

        // tracking - announcements are ready
        if (eventName === adapter.loginCmd && countOfActiveAnnouncements) {
            tracking(ANNOUNCEMENT_READY, getAnnouncementsCache())
        }

        logger.log(
            ` call ${GAME_CALLBACK.UNREAD_ANNOUNCEMENTS} - ${countOfActiveAnnouncements}`
        )
    }

    const onOpenAnnouncements = () => {
        const loginData = getLoginData()
        if (!loginData) {
            return
        }

        loadMessages(context)(loginData)
        logger.info('onOpenAnnouncement handler for user %O', loginData)

        tracking(OPEN_ANNOUNCEMENTS, getAnnouncementsCache())
    }

    return {
        onLogin,
        onLogout,
        onGetMessageStatus,
        onOpenAnnouncements
    }
}
